import _ from 'lodash';
import { HttpClient } from 'api/helpers/HttpClient';
import { store } from 'store';
import { getRegion } from 'utils/Region';

export const getWorkflowStart = async (params = '') => {
  const claroAdEnable =
    JSON.parse(store.getState().metadata?.cv_advertising_config || '{}')?.[
      getRegion()
    ]?.enable ||
    JSON.parse(store.getState().metadata?.cv_advertising_config || '{}')
      ?.default?.enable;

  const apiCall = new HttpClient({ hasClaroAdActive: claroAdEnable });

  const isV1orV2 = params?.includes('v1') || params?.includes('v2');
  const firstSplit = params.split('/');
  const secondSplit = firstSplit?.[(isV1orV2 ? 4 : 3)].split('?');

  const url = [...firstSplit.slice(0, isV1orV2 ? 4 : 3), secondSplit[0]].join(
    '/',
  );
  const paramsArray = secondSplit.slice(1);
  const paramsList = paramsArray[0].split('&');
  const paramsObject = {};

  paramsList.forEach(parameter => {
    const [key, value] = parameter.split('=');
    paramsObject[key] = value;
  });

    if(isV1orV2){
      paramsObject.api_version = null;
    }

  try {
    const { data } = await apiCall.get(url, paramsObject);
    const status = _.get(data, 'status', _.get(data, 'response.status', 0));
    if (parseInt(status, 10) !== 0) {
      const error = _.get(data, 'response', data);
      return error !== null ? error : data;
    }
    return data.response;
  } catch (error) {
    return error;
  }
};
